module.exports = __webpack_public_path__ + "static/media/kempinski.2cdf8b61.webp";